import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap, takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { logout } from '@/app/store/authentication/authentication.actions';
import { ToastrService } from 'ngx-toastr';
import { RequestCancellationService } from '@/app/core/services/request-cancellation.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        public toastService: ToastrService,
        private requestCancellationService: RequestCancellationService,
    ) { }

    store = inject(Store);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Get the auth token from localStorage
        let token = JSON.parse(localStorage.getItem('token') || '""');

        if(req.url.includes('UserCrendential/ValidateOTP'))
            token = JSON.parse(localStorage.getItem('x-token') || '""');
        
        // Clone the request to add the authorization header
        const clonedRequest = token ? req.clone({
            setHeaders: {
                Authorization: token
            }
        }) : req;

        // Pass the cloned request to the next handler and catch errors
        return next.handle(clonedRequest).pipe(
            takeUntil(this.requestCancellationService.onCancelRequests),
            tap((event: HttpEvent<any>) => {}, (err: any) => {
            if (err instanceof HttpErrorResponse) {
                console.log("err===>", err);
                if (err.status == 403) {
                    this.showErrorMessage(err?.error?.message || 'Insufficient Permissions');
                }
                else if ([400, 402, 405].indexOf(err?.status) > -1 && !err.ok) {
                    if(err.status == 400 && err?.error?.title){
                        if(err?.error?.errors && Object.keys(err?.error?.errors)?.length > 0){
                            const keys = Object.keys(err?.error?.errors);
                            this.showErrorMessage(err?.error?.errors[keys[0]][0] || 'Bad request');
                        }
                        else{
                            this.showErrorMessage(err?.error?.title || 'Bad request');
                        }
                    }
                    else {
                         this.showErrorMessage(err?.error?.message || 'Bad request');
                    }
                } else if (err.status === 401) {
                    // Cancel all ongoing requests
                    this.requestCancellationService.cancelAllRequests();
                    
                    // Dispatch logout action
                    this.store.dispatch(logout());

                    // Prevent error message while logout api error
                    if(!req.url.includes("UserCrendential/Logout"))
                        this.showErrorMessage(err?.error?.message || 'Unauthorized access');

                } else if (err.status === 404 || (err.error && err.error.error === 'Not Found')) {
                    this.showErrorMessage(err?.error?.message || 'Resource not found');

                } else if (err.status === 500) {
                    this.showErrorMessage(err?.error?.message || 'Internal server error');
                }
            }
        }));
    }

    private showErrorMessage(message: string): void {
        this.toastService.error(message, 'Error', {
            timeOut: 3000,
            closeButton: true,
            positionClass: "toast-top-right",
            tapToDismiss: true,
        });
    }
}
